export default [
	{
		path: '/app/policies',
		name: 'policies.manage',
		component: () =>
			import(
				'../../../components/dashboard/back-office/policies/ManagePoliciesComponent.vue'
			),
		meta: {
			allowedUsers: ['back-office']
		}
	},
	{
		path: '/app/policies/new',
		name: 'policies.new',
		component: () =>
			import(
				'../../../components/dashboard/back-office/policies/NewPolicyComponent.vue'
			),
		meta: {
			allowedUsers: ['back-office']
		}
	},
	{
		path: '/app/policies/:policy',
		name: 'policies.show',
		component: () =>
			import(
				'../../../components/dashboard/back-office/policies/ViewPolicyComponent.vue'
			),
		meta: {
			allowedUsers: ['back-office']
		}
	}
];
